
import React from 'react';
import { FormProvider } from '../../context/FormContext';
import FormContent from './FormContent';

const TeachingReportForm: React.FC = () => {
  return (
    <FormProvider>
        <FormContent />
    </FormProvider>
  );
};

export default TeachingReportForm;
